import { SBAPI } from '@supplement-bacon/react-toolkit/utils'
import { TableParams } from '@supplement-bacon/sb-table-filters'
import { BusinessProfileStatus } from '../../models/business/BusinessProfileStatus'
import { BUSINESS_PROFILE_STATUSES_URL } from '../../utils/urls'

const fetchBusinessProfileStatuses = (params: TableParams) =>
  SBAPI.FetchPaginated<BusinessProfileStatus[]>(
    BUSINESS_PROFILE_STATUSES_URL,
    params
  )

const fetchBusinessProfileStatusById = (id: number, params?: TableParams) =>
  SBAPI.Fetch<BusinessProfileStatus>(
    `${BUSINESS_PROFILE_STATUSES_URL}/${id}`,
    params
  )

const createBusinessProfileStatus = (
  businessProfileStatus: BusinessProfileStatus
) => SBAPI.Post(BUSINESS_PROFILE_STATUSES_URL, businessProfileStatus)

const updateBusinessProfileStatus = (
  businessProfileStatus: BusinessProfileStatus
) =>
  SBAPI.Put(
    `${BUSINESS_PROFILE_STATUSES_URL}/${businessProfileStatus.id}`,
    businessProfileStatus
  )

const deleteBusinessProfileStatus = (
  businessProfileStatus: BusinessProfileStatus
) =>
  SBAPI.Delete(`${BUSINESS_PROFILE_STATUSES_URL}/${businessProfileStatus.id}`)

export {
  createBusinessProfileStatus,
  deleteBusinessProfileStatus,
  fetchBusinessProfileStatusById,
  fetchBusinessProfileStatuses,
  updateBusinessProfileStatus,
}
